<script setup lang="ts">
import { toRefs } from 'vue';
import ProgressBar from 'primevue/progressbar';
import { PastResultTreatmentGoalMeasurement } from '@/types';

interface Props {
  data: PastResultTreatmentGoalMeasurement;
}
const props = defineProps<Props>();

const { data } = toRefs(props);
</script>

<template>
  <div class="flex flex-column justify-content-between lg:flex-row border-1 border-rounded border-200 mt-3 p-3 text-sm">
    <div class="text-justify">{{ data.treatment_goal.description }}</div>
    <div class="flex flex-column align-items-end pl-3">
      <div class="mb-2 pt-3 lg:pt-0">
        <b class="mr-1 text-sm">{{ data.percentage }}%</b>
        <span class="dark-medium text-sm">Completed</span>
      </div>
      <div>
        <ProgressBar :value="data.percentage" :show-value="false" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.border-rounded {
  border-radius: 8px;
}
.p-progressbar {
  color: $grayDark;
  width: 120px;
  height: 16px;
  border-radius: 4px;
}
::v-deep(.p-progressbar) {
  .p-progressbar-value {
    background: var(--primary-color-medium);
  }
}
.dark-medium {
  color: $grayDark;
}
</style>
